import TextInputPage from '@app-studio-web/ui/pages/TextInputPage'
import useUpdateMode from '@hooks/useUpdateMode'
import { saveAnswer } from '@utils/onboardingStorage'
import { useSearchParams, useSubmit } from 'react-router-dom'

const QUESTION_KEY = 'feeling'

export default function FeelingPage() {
  const submit = useSubmit()
  const [searchParams] = useSearchParams()
  const value = searchParams.get('value')
  const preselectedValue = value || undefined
  const { isUpdate, postToReactNative } = useUpdateMode()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    const formData = new FormData(event.currentTarget)
    const feeling = formData.get('feeling') as string
    if (!feeling) return

    const answer = {
      question_key: QUESTION_KEY,
      question: "What's something you want to feel when this space is clear?",
      answer_key: feeling.toLowerCase(),
      answer: feeling,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(formData, { method: 'post' })
    }
  }

  const handleSkip = () => {
    const answer = {
      question_key: QUESTION_KEY,
      question: "What's something you want to feel when this space is clear?",
      answer_key: 'skipped',
      answer: 'Skipped',
    }

    const formData = new FormData()
    formData.append('feeling', 'skipped')
    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(formData, { method: 'post' })
    }
  }

  return (
    <TextInputPage
      heading="pages.onboarding.feeling.heading"
      placeholder="pages.onboarding.feeling.placeholder"
      onSubmit={handleSubmit}
      onSkip={handleSkip}
      inputName="feeling"
      value={preselectedValue}
    />
  )
}
